import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onRenderTriggered, ref, watch } from "vue";
import LoadingGif from "../../../ui-components/loading/LoadingGif.vue";
import { type ButtonInfo } from "./dashboard-tooltip-button-manager.module";

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardTooltipButton',
  props: {
    info: { type: Object, required: true },
    kind: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const isLoading = ref(false);
const buttonDisabled = computed(() => props.info.disabled || isLoading.value);
const classes = computed(() => {
  const ret: string[] = [];
  if (buttonDisabled.value) {
    ret.push("disabled");
  }
  ret.push(props.kind);
  return ret;
});
const svgStyles = {
  marginTop: `${props.info.svgMarginTop || 0}px`,
  marginLeft: `${props.info.svgMarginLeft || 0}px`,
  transformOrigin: props.info.svgTransformOrigin || "center",
  transform: props.info.svgTransform || "",
};
const btnText = ref<Element | null>(null);
function setProps() {
  const root = btnText.value?.parentElement as HTMLElement;
  if (!root) {
    return;
  }
  root.setAttribute(
    "class",
    [
      "stm-toolbar-button",
      "tabToolbarButton",
      "tab-widget",
      "lineage",
      ...classes.value,
    ].join(" ")
  );
  root.setAttribute("tabindex", "-1");
  root.setAttribute("aria-expanded", "false");
  root.setAttribute("role", "button");
  root.setAttribute("title", props.info.text);
  root.onclick = () => buttonClicked();
}
onMounted(() => setProps());
onRenderTriggered(() => setProps());
watch(classes, (oldClasses: string[], newClasses: string[]) => setProps());
async function buttonClicked() {
  isLoading.value = true;
  try {
    await props.info.onClicked();
  } finally {
    isLoading.value = false;
  }
}

const __returned__ = { props, isLoading, buttonDisabled, classes, svgStyles, btnText, setProps, buttonClicked, LoadingGif }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})